
<div class="form-group mb-10" *ngIf="isSearchBarAvailable()">
    <div class="input-group w-auto" style="margin-right: 5px; flex-wrap: nowrap;">
        <select name="operator" id="operator-select" class="form-select mt-2 operator-select" style="min-width: 150px;"
            [value]="this.selectedNode.operatorSelected" (change)="refreshCriteria()"
            #operatorInput>
            <option value="eq" title="Any column content has the exact provided value">Match</option>
            <option value="sw" title="Any column content starts with the provided value">Starts with</option>
            <option value="cn" title="Any column content includes the provided value">Contains</option>
            <option value="ew" title="Any column content ends with the provided value">Ends with</option>
            <option value="in"
                title="Any column content has the exact value(s) provided and separated by vertical bar symbol">With
            </option>
        </select>
        <input #filterBox type="text" size="100" class="form-control w-auto d-flex mt-2 ml-2"
            [placeholder]="this.selectedNode.getPlaceHolderTemplate()" [title]="this.selectedNode.getPlaceHolderToolTipTemplate()" [value]="getCriteria()"
            (keyup)="filter($event)" (keydown.enter)="addedToHistory()" (paste)="onPaste($event)" (blur)="onBlur()" />

        <div class="btn-group" role="group" style="margin-top: 7px; margin-bottom: -1px;">
            <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
                aria-label="Latest search criteria" title="Latest search criteria">
            </button>
            <ul class="dropdown-menu scroll-container" style="max-height: 400px; overflow-y: auto;">
                <li *ngIf="showHistoryItem()">
                    <span class="d-inline-block full-width m-3" style="text-align: center;">
                        No items
                    </span>
                </li>
                <li *ngFor="let item of includeAndOrderHistories()">
                    <span class="d-inline-block full-width" style="text-align: right;">
                        <a class="dropdown-item" (click)="setItemHistory(item)">{{ includeLabel(item) }}</a>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</div>

